
(function($) { 

    $(document).ready(function() {
    var lastScrollTop = 0, delta = 5;
    $(window).scroll(function(){
       var nowScrollTop = $(this).scrollTop();
       if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
           if (nowScrollTop > lastScrollTop){
                // ACTION ON
                // SCROLLING DOWN
                $( "#cookie-notice" ).css("transition", "transform .375s ease-out,opacity .15s ease-out");
                $( "#cookie-notice" ).css("transform", "translateY(100%)"); 
           } else {
                // ACTION ON
                // SCROLLING UP
                $( "#cookie-notice" ).css("transition", "transform .375s ease-in,opacity .15s ease-in");
                $( "#cookie-notice" ).css("transform", "translateY(0%)"); 
          }
          lastScrollTop = nowScrollTop;
       }
    });


        $('.gk-upper-head .notranslate').keypress(function (e) {
            var key = e.which;
            if(key == 13)  // the enter key code
             {
                $('.header-link .fa-angle-down').click();
                return false;  
             }
           });
           $('.site-menu .notranslate').keypress(function (e) {
            var key = e.which;
            if(key == 13)  // the enter key code
             {
                $('.site-menu .fa-angle-down').click();
                return false;  
             }
           });   

         $('.notranslate').keyup(function(evt) {
            if(evt.key === "Enter") {
                $("#gt-modal").attr("tabindex",-1).focus();
             }
            });
        
            $("[data-show]").on("click", function(e){
                e.preventDefault();
                e.stopPropagation();
                var offcanvas_id =  $(this).attr('data-show');
                $(offcanvas_id).toggleClass("show");
            }); 
        
            $(".btn-close, .screen-overlay").click(function(e){
                $(".site-menu").removeClass("show");
            });
        
    });
})( jQuery ); 




(function($) {

    /**
     * Add <a /> for skip to content and navigation to DOM. Can 
     * be accessed and viewed by pressing tab, they are only 
     * visually hidden when not in focus.
     */
    var skipToHtml = {
        skipToContent: '<a id="skip-to-content" class="hide-visually" href="#main" accesskey="I" title="Hoppa till sidans innehåll">Hoppa till sidans innehåll</a>',
        skipToNavigation: '<a id="skip-to-navigation" class="hide-visually" href="#menu-button" accesskey="N" title="Hoppa till sidans navigering">Hoppa till sidans navigering</a>'
    }
    
    var $body = $('body');
    var $skipToContent = $(skipToHtml.skipToContent);
    var $skipToNavigation = $(skipToHtml.skipToNavigation);

    $body.prepend($skipToContent);
    $body.prepend($skipToNavigation);

    $skipToNavigation.focusin(function() {
        $this = $(this);
        $this.attr('style', 'position:relative; clip:rect(auto)');
    });

    $skipToNavigation.focusout(function() {
        $this = $(this);
        $this.attr('style', '');
    });

    $skipToContent.focusin(function() {
        $this = $(this);
        $this.attr('style', 'position:relative; clip:rect(auto)');
    });

    $skipToContent.focusout(function() {
        $this = $(this);
        $this.attr('style', '');
    });

})(jQuery);



var site_menu = function() {

    var $ = jQuery;
    var $body;
    var $site_menu;
    var $site_menu_tree;
    var $site_menu_toggler;

    return {
        
        build: function() {

            
         
             $('.site-menu li.current_page_item').parents('ul').each(function(i, e) {

                $(this).show();
            });
    
        
            $('.site-tree li').each(function() {
                
                $li = $(this);
        
                if($li.children('ul').length) {
        
                    if($li.hasClass('current_page_ancestor')) {
                        $li.find('> a').after('<button aria-expanded="true"><i class="fa fa-minus-circle direction"></i></button>');
                    }
                    else {
                        
                        var $ul = $li.find('> ul');
        
                        if($ul.is(':visible')) {
                            $li.find('> a').after('<button aria-expanded="true"><i class="fa fa-minus-circle direction"></i></button>');
                        }
                        else {
                            $li.find('> a').after('<button aria-expanded="false"><i class="fa fa-plus-circle direction"></i></button>');
                        }
                    }
                }
            });

            $child = $('.site-menu li.current_page_item > ul');
            
            if($child.length) {
                $child.parent().find('> button').remove();
                $child.parent().find('> a').after('<button aria-expanded="true"><i class="fa fa-minus-circle direction"></i></button>');
                $child.show();
            }

                    
            $('.site-tree li button').on('click', function(event) {

                event.stopPropagation();

                var $li = $(this).parent();
                var $child = $(this).parent().find('> ul');
                var $toggle = $child.find('li:first-child .direction');
                
                if($child.is(':visible')) {
                    $child.slideUp(250);
                    console.log('add plus');
                    $('> button i.direction', $li).addClass('fa-plus-circle').removeClass('fa-minus-circle');
                    $('> button', $li).attr('aria-expanded', function (i, attr) {
                        return attr == 'true' ? 'false' : 'true'
                    });
                }
                else {
                    $child.slideDown(250);
                    $('> button i.direction', $li).addClass('fa-minus-circle').removeClass('fa-plus-circle');
                    $('> button', $li).attr('aria-expanded', function (i, attr) {
                        return attr == 'true' ? 'false' : 'true'
                    });
                }

                return false;
            });
        },
        init: function() {
            
            $body = $('body');
            $site_menu = $('.site-menu');
            $site_menu_toggler = $('.site-menu-toggler');
            $site_menu_tree = $('.site-menu-tree');
            
            // Default <body /> class
            $body.addClass('site-menu-hidden')

            // Toggle menu
            $site_menu_toggler.click(function() {
                $body.toggleClass('site-menu-hidden site-menu-visible'); 
                $('.site-menu-visible .site-menu .top-area a').focus();
            });
         
            $('.site-menu-background').click(function () {
                $site_menu_toggler.click();
                $('.site-menu-toggler').focus();
            });

            $('.site-menu .top-area button').click(function() {
                $site_menu_toggler.click();
                $('.site-menu-toggler').focus();
            });

            // CLose menu and focus element when menu close
            $(".site-menu .site-links li a:last").focusout(function(){
                $site_menu_toggler.click();
                $('.site-menu-toggler').focus();
                //$('.site-menu .top-area a').focus();
            });

            this.build();

        }
    }
}();

jQuery("document").ready(function () {

    // Do not load before jQuery is loaded.
    site_menu.init();
});